var modules_a3dacc96 = {"list":"List_module_list__b7d415a8","ordered":"List_module_ordered__b7d415a8 List_module_list__b7d415a8","item":"List_module_item__b7d415a8","unordered":"List_module_unordered__b7d415a8 List_module_list__b7d415a8","with-icon":"List_module_withIcon__b7d415a8","icon":"List_module_icon__b7d415a8"};
import "../../../assets/esm/components/Typography/src/ListItem~CoS1JWfZ.css";

export { modules_a3dacc96 as default };
//# sourceMappingURL=List.module.less.js.map
